import { useEffect } from 'react';

import { ENV } from '@hcs/webapps';
export const PageTitleDevTool = () => {
  useEffect(() => {
    if (ENV === 'prod') return;
    const originalTitle = document.title;
    const envSegment = window.location.hostname.split('.').at(-4);
    const localSegment = window.location.hostname.split('.').at(-5);
    const pullSegment = window.location.hostname.split('.').at(0);
    if (pullSegment?.includes('pull')) {
      document.title = `[Pull] ${originalTitle.replace('[Pull] ', '')}`;
    } else if (localSegment === 'local') {
      document.title = `[Local] ${originalTitle.replace('[Local] ', '')}`;
    } else if (envSegment === 'dev' || envSegment === 'stage') {
      const titleEnv = `[${envSegment.charAt(0).toUpperCase() + envSegment.slice(1)}]`;
      document.title = `${titleEnv} ${originalTitle.replace(titleEnv, '')}`;
    }
  }, []);

  return null;
};
